"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import Link from "next/link";
import SitePage, { PageHero } from "@/components/site/SitePage";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <SitePage>
      <PageHero>
        <div className="wrap stack g24 items-start">
          <span className="eyebrow in">Error</span>
          <h1 className="h1 in d1">Something went wrong</h1>
          <p className="lead in d2 max-w-[560px]">
            We apologize for the inconvenience. An error has occurred while loading this page.
          </p>
          <div className="row g12 in d3">
            <button type="button" onClick={reset} className="btn btn-primary">
              Try again
            </button>
            <Link href="/" className="btn btn-outline">
              Back to home
            </Link>
          </div>
        </div>
      </PageHero>
    </SitePage>
  );
}
